<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="false">
      <CenterSearchForm
        :has_nav_bar="false"
        :width_class="page_info.center_width_class"
        :show_pagination="false"
        :disabled="is_loading"
        :is_on_search_page="false"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></CenterSearchForm>
      <div class="componet-has-search-bar white">&nbsp;</div>
      <Slider :items="slides"  v-show="slides.length > 0" @on-click="clicked_slide" ></Slider>
      <CardedSectionHeader
        icon="mdi-dot"
        label="What is Busyug ?"
        id="home_about_introduction"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <p class="font-weight-medium text--darken-1">
            <b>Busyug</b> is the IP of Solidcare Service PTY LTD,
            which is a business solution focused company. <br />
            <br />
            <b
              >Busyug is a locally developed online business
              directory</b
            >
            and represents a great marketing opportunity for various local
            companies and organizations. The Web Application captures and
            displays registered business information and with this information
            customer can search for business by location, category, services
            provided, viewing contact information, company description, opening
            and closing hours, giving customer’s readily accessible information
            from the comfort of their home using their mobile devices, laptops
            or personal computers. This greatly assists anyone looking for any
            particular business/service to find them easier and with that get a
            lot more options when looking for services in a particular industry.
            Our directory is search targeted, timely and very cost effective,
            displaying business categorically and listing them in an industry
            specific manner.
          </p>
          <v-row no-gutters>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5 mb-5"
                to="/about"
              >
                Learn More ...
              </v-btn>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <CardedSectionHeader
        icon="mdi-dot"
        label="Latest Promotions"
        id="home_lastest_promotions"
        v-if="latest_promotions.length > 0"
      ></CardedSectionHeader>
      <CardedDisplay v-if="latest_promotions.length > 0">
        <PlainDisplay :show_icon="false">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pa-2"
              v-for="(promotion, index) in latest_promotions"
              :key="index"
            >
              <PromotionHeader
                :is_loading="is_loading"
                :promotion="promotion"
                :is_owner_view="false"
                :is_in_admin_view="false"
                :is_in_public_view="true"
                cmp_class="d-flex justify-space-between elevation-2 text-left"
              ></PromotionHeader>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5"
                to="/promotions"
              >
                View Promotions
              </v-btn>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <CardedSectionHeader
        icon="mdi-dot"
        label="Latest Businesses"
        id="home_latest_businesses"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <v-row>
            <v-col
              no-gutters
              cols="6"
              v-for="(business, index) in latest_businesses"
              :key="index"
            >
              <div
                class="d-flex justify-space-between pa-2 pointer elevation-5"
                :id="'home_bsns_id_' + business.id"
                @click="view_business(business)"
              >
                <div class="grey lighten-5 pa-1 round-4 elevation-2">
                  <v-img
                    :src="business.logo"
                    :width="logo_width"
                    :height="logo_width"
                    :max-width="logo_width"
                    :min-height="logo_width"
                    grey
                  >
                  </v-img>
                </div>
                <div
                  class="flex-grow-1 pa-2 pb-0 d-flex flex-column justify-space-between"
                  :style="'min-height:' + (logo_width + 10) + 'px'"
                >
                  <div>
                    <div class="d-flex justify-space-between">
                      <div class="text-left">
                        <v-rating
                          background-color="warning lighten-1"
                          color="warning"
                          empty-icon="mdi-star-outline"
                          full-icon="mdi-star"
                          half-icon="mdi-star-half-full"
                          hover
                          length="5"
                          size="15"
                          :value="parseFloat(business.rating)"
                          :readonly="true"
                        ></v-rating>
                      </div>
                      <div class="text-right">
                        <span class="success--text local-badge"
                          ><small>
                            {{
                              parseInt(business.is_local_company) == 1
                                ? "LOCAL COMPANY"
                                : "NOT LOCAL"
                            }}
                          </small></span
                        >
                      </div>
                    </div>
                    <div class="text-left directory-business-name">
                      <span class="success--text mr-1"
                        ><b>#{{ business.id }}</b></span
                      >
                      {{ business.name }}
                    </div>
                    <div class="text-left directory-business-tagline">
                      {{ business.tag_line }}
                    </div>
                  </div>
                  <div class="grey lighten-4 d-flex justify-space-between pa-1">
                    <v-chip
                      x-small
                      label
                      class="white--text ml-2"
                      :color="business.open_btn.color"
                      ><b class="">
                        {{ business.open_btn.open_status }}</b
                      ></v-chip
                    >
                    <v-btn
                      x-small
                      width="100"
                      outlined
                      color="success"
                      :disabled="is_loading"
                    >
                      <v-icon left>mdi-eye</v-icon>
                      view
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5"
                to="/directory"
              >
                View Business Directory
              </v-btn>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <CardedSectionHeader
        icon="mdi-dot"
        label="Top Categories"
        id="home_top_categories"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <v-row no-gutters>
            <v-col
              no-gutters
              cols="3"
              v-for="(category, index) in top_categories"
              :key="index"
            >
              <CategoryTile
                :category="category"
                :belongings="belongings"
                :sub_categories="sub_categories"
                @on-click="select_category"
              >
              </CategoryTile>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5"
                to="/categories"
              >
                View All Business Categories
              </v-btn>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <CardedSectionHeader
        icon="mdi-dot"
        label="Most Viewed Businesses"
        id="home_most_viewed_businesses"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <v-row>
            <v-col
              no-gutters
              cols="6"
              v-for="(business, index) in most_viewed_businesses"
              :key="index"
            >
              <div
                class="d-flex justify-space-between pa-2 pointer elevation-5"
                :id="'home_bsns_id_' + business.id"
                @click="view_business(business)"
              >
                <div class="grey lighten-5 pa-1 round-4 elevation-2">
                  <v-img
                    :src="business.logo"
                    :width="logo_width"
                    :height="logo_width"
                    :max-width="logo_width"
                    :min-height="logo_width"
                    grey
                  >
                  </v-img>
                </div>
                <div
                  class="flex-grow-1 pa-2 pb-0 d-flex flex-column justify-space-between"
                  :style="'min-height:' + (logo_width + 10) + 'px'"
                >
                  <div>
                    <div class="d-flex justify-space-between">
                      <div class="text-left">
                        <v-rating
                          background-color="warning lighten-1"
                          color="warning"
                          empty-icon="mdi-star-outline"
                          full-icon="mdi-star"
                          half-icon="mdi-star-half-full"
                          hover
                          length="5"
                          size="15"
                          :value="parseFloat(business.rating)"
                          :readonly="true"
                        ></v-rating>
                      </div>
                      <div class="text-right">
                        <span class="success--text local-badge"
                          ><small>
                            {{
                              parseInt(business.is_local_company) == 1
                                ? "LOCAL COMPANY"
                                : "NOT LOCAL"
                            }}
                          </small></span
                        >
                      </div>
                    </div>
                    <div class="text-left directory-business-name">
                      <span class="success--text mr-1"
                        ><b>#{{ business.id }}</b></span
                      >
                      {{ business.name }}
                    </div>
                    <div class="text-left directory-business-tagline">
                      {{ business.tag_line }}
                    </div>
                  </div>
                  <div class="grey lighten-4 d-flex justify-space-between pa-1">
                    <v-chip
                      x-small
                      label
                      class="white--text ml-2"
                      :color="business.open_btn.color"
                      ><b class="">
                        {{ business.open_btn.open_status }}</b
                      ></v-chip
                    >
                    <v-btn
                      x-small
                      width="100"
                      outlined
                      color="success"
                      :disabled="is_loading"
                    >
                      <v-icon left>mdi-eye</v-icon>
                      view
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5"
                to="/directory"
              >
                View Business Directory
              </v-btn>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterSearchForm from "./../../components/CenterSearchForm";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CardedDisplay from "./../../components/CardedDisplay";
import PlainDisplay from "./../../components/PlainDisplay";
import PromotionHeader from "./../../components/PromotionHeader";
import CategoryTile from "./../../components/CategoryTile";
import Slider from "./../../components/Slider";

import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";

export default {
  name: "Home",
  components: {
    Page,
    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,
    CenterPageColumn,
    CenterSearchForm,
    Footer,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CategoryTile,
    Slider
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "home",
    quick_links: [
      // {
      //   text: "Search Businesses",
      //   href: "#home_search_bar",
      // },
      // {
      //   text: "About US",
      //   href: "#home_about_introduction",
      // },
    ],
    page_info: page_info,
    latest_promotions: [],
    latest_businesses: [],
    most_viewed_businesses: [],
    top_categories: [],
    belongings: {},
    sub_categories: {},
    logo_width: 100,
    holidays: [],
    slides: []
  }),
  methods: {
    get_open_status(business) {
      var is_open = false;
      var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      var this_device_day = new Date().getDay();
      var device_day = days[this_device_day];

      var op_value = business[device_day + "_openning_time_display"];
      var cl_value = business[device_day + "_closing_time_display"];

      if (op_value.length == 0) {
        op_value = "not set";
      }
      if (cl_value.length == 0) {
        cl_value = "not set";
      }

      if (
        op_value != "closed" &&
        cl_value != "closed" &&
        op_value != "not set" &&
        cl_value != "not set"
      ) {
        //then lets get the times schedule times
        var start_x = parseFloat(business[device_day + "_openning_time_value"]); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
        var closes_x = parseFloat(business[device_day + "_closing_time_value"]); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
        var device_date_x = new Date();
        var now_device_hours = device_date_x.getHours();
        var now_device_mins = device_date_x.getMinutes();
        var now_device_time = parseFloat(
          now_device_hours + "." + now_device_mins
        );
        if (now_device_time >= start_x && now_device_time <= closes_x) {
          is_open = true;
        }
      } else if (op_value == "not set" || cl_value != "not set") {
        is_open = -1;
      }

      return is_open;
    },
    get_holiday_open_status(business) {
      var DateTodayDevice = new Date();
      var TodayDeviceDate = DateTodayDevice.getDate();
      var TodayDeviceMonth = DateTodayDevice.getMonth();

      var is_open = false;
      var is_a_holiday_today = false;
      if (business && this.holidays && business.business_holliday_schedules) {
        //index the business holiday entries
        var indexed_business_holidays = {};
        for (
          var index = 0;
          index < business.business_holliday_schedules.length;
          index++
        ) {
          var schedule = business.business_holliday_schedules[index];
          indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
        }

        //go through the application holidays config
        for (var index = 0; index < this.holidays.length; index++) {
          var holiday = this.holidays[index];

          //used to detect for today
          var DateForHoliday = new Date(holiday.starts_on);
          var DateForHolidayDate = DateForHoliday.getDate();
          var DateForHolidayMonth = DateForHoliday.getMonth();

          if (
            TodayDeviceDate != DateForHolidayDate ||
            TodayDeviceMonth != DateForHolidayMonth
          ) {
            //continue its not a holiday today so no need to check further
            continue;
          }

          is_a_holiday_today = true;

          //look for this holiday from the business object
          if (indexed_business_holidays[parseInt(holiday.id)]) {
            var schedule = indexed_business_holidays[parseInt(holiday.id)];
            var op_value = schedule.opens;
            var cl_value = schedule.closes;
            if (op_value.length == 0) {
              op_value = "not set";
            }
            if (cl_value.length == 0) {
              cl_value = "not set";
            }
            //for the business to be oppened on this holiday it must be today
            //and having a schedule setup, thats why this logic is written here
            if (schedule.opens_time != "closed") {
              //then lets get the times schedule times
              var start_x = parseFloat(schedule.opens_time); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
              var closes_x = parseFloat(schedule.ends_time); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
              var device_date_x = new Date();
              var now_device_hours = device_date_x.getHours();
              var now_device_mins = device_date_x.getMinutes();
              var now_device_time = parseFloat(
                now_device_hours + "." + now_device_mins
              );
              if (now_device_time >= start_x && now_device_time <= closes_x) {
                is_open = true;
              }
            } else {
              is_open = false;
            }
            break;
          } else {
            //because the business is missing a holiiday entry
            is_open = -1;
          }
        }
      } else {
        is_open = -1; //not set
      }

      return {
        is_open: is_open,
        is_a_holiday_today: is_a_holiday_today,
      };
    },
    set_is_business_open(business) {
      var holiday_schedules = this.get_holiday_open_status(business);
      var normal_schedule_open = this.get_open_status(business);
      var msg = "";
      var color = "";
      var is_open = false;
      var open_status = "";
      var is_holiday_open = holiday_schedules.is_open;
      var is_a_holiday_today = holiday_schedules.is_a_holiday_today;
      var is_week_open = normal_schedule_open;

      if (is_a_holiday_today && is_holiday_open === -1) {
        //note the === strict comparison used here
        msg =
          "This business may be open or close, because there is no schedule setup for this holiday";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      } else if (is_a_holiday_today && is_holiday_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED, by this time on this holiday";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_a_holiday_today && is_holiday_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN, by this time on this holiday";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_week_open === -1) {
        msg =
          "This business may be open or close, because there is no schedule setup for today";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      }
      return {
        msg: msg,
        color: color,
        is_open: is_open,
        open_status: open_status,
      };
    },
    set_qick_links() {
      var qls = [
        // {
        //   text: "Search Businesses",
        //   href: "#home_search_bar",
        // },
        // {
        //   text: "Know About Us",
        //   href: "#home_about_introduction",
        // },
      ];
      if (this.latest_promotions.length > 0) {
        qls.push({
          text: "Latest Promotions",
          href: "#home_lastest_promotions",
        });
      }
      qls.push({
        text: "Latest Businesses",
        href: "#home_latest_businesses",
      });
      qls.push({
        text: "Top Categories",
        href: "#home_top_categories",
      });
      qls.push({
        text: "Most Viewd",
        href: "#home_most_viewed_businesses",
      });

      this.quick_links = qls;
    },
    set_promo_expired(promo, php_time_now) {
      promo.expiry = "";
      if (php_time_now < parseFloat(promo.starts_on_timestamp)) {
        promo.expiry = "pending";
      } else if (
        php_time_now >= parseFloat(promo.starts_on_timestamp) &&
        php_time_now <= parseFloat(promo.ends_on_timestamp)
      ) {
        promo.expiry = "live";
      } else if (php_time_now > parseFloat(promo.ends_on_timestamp)) {
        promo.expiry = "expired";
      }
      return promo;
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    load_home_page() {
      var time_now = Utils.date_str_to_php_time();
      this.$emit("on-show-loader");
      ServerClient.Home.load_home_page(
        {
          time_now: time_now,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //console.log("Home res",res);

          //slides
          this.slides = res.home_page_slides.sliders;

          //holidays
          this.holidays = res.holidays.hollidays;

          //latest promotions
          var fpromos = [];
          for (
            var index = 0;
            index < res.latest_promotions.promotions.length;
            index++
          ) {
            var fpromo = res.latest_promotions.promotions[index];
            //expiry
            fpromo = this.set_promo_expired(fpromo, time_now);
            fpromos.push(fpromo);
          }
          this.latest_promotions = fpromos;

          //latest businesses
          var b_list = [];
          for (
            var index = 0;
            index < res.latest_businesses.businesses.length;
            index++
          ) {
            var business = res.latest_businesses.businesses[index];
            //get open status
            business.open_btn = this.set_is_business_open(business);
            b_list.push(business);
          }
          this.latest_businesses = b_list;

          //top categories
          this.belongings = res.index_category_belongings.belongings;
          this.sub_categories = res.indexed_sub_categories.sub_categories;
          this.top_categories = res.top_categories.categories;

          //most viewed businesses
          var mb_list = [];
          for (
            var index = 0;
            index < res.most_viewed_businesses.businesses.length;
            index++
          ) {
            var business = res.most_viewed_businesses.businesses[index];
            //get open status
            business.open_btn = this.set_is_business_open(business);
            mb_list.push(business);
          }
          this.most_viewed_businesses = mb_list;

          //quick links
          this.set_qick_links();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Encounted errors while loading home page items ",
            errors
          );
        }
      );
    },
    view_business(business) {
      this.$router.push("/businesses/" + business.id);
    },
    select_category(category) {
      this.$router.push("/categories/" + category.id);
    },
    clicked_slide(slide){
        if(slide.click_url.length > 0){
          window.open(slide.click_url,"_blank");
        }
    }
  },
  mounted() {
    this.load_home_page();
  },
};
</script>